import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@material-ui/core';
import { defineMessages, FormattedMessage } from 'react-intl';

import * as actions from '../../../state';

// localization
const messages = defineMessages({
  ENABLE_NOTIFICATIONS: {
    id: 'ENABLE_NOTIFICATIONS',
    defaultMessage: 'Enable Notifications',
  },
  ENABLE_NOTIFICATIONS_INFO: {
    id: 'ENABLE_NOTIFICATIONS_INFO',
    // eslint-disable-next-line
    defaultMessage: 'This board contains charts with alerts that triggers browser notifications. You will be asked to allow permissions on this page and, after granting permission, notifications will be enabled.',
  },
  DISMISS: {
    id: 'DISMISS',
    defaultMessage: 'Dismiss',
  },
});

function BroNoConfirm() {
  const [showDialog, setShowDialog] = useState(true);
  const charts = useSelector(actions.readStateCharts);

  const browserSupportsBroNo = 'Notification' in window;
  const needPermission = browserSupportsBroNo && ['granted', 'denied'].includes(Notification.permission) === false;

  let hasAlertsWithBroNo = false;
  charts.forEach((chart) => { // iterate over charts
    if (chart.data_sources && chart.data_sources.length) { // does chart have sources?
      chart.data_sources.forEach((source) => { // iterate over sources
        if (source.alerts && source.alerts.length) { // does source have alerts?
          source.alerts.forEach((alert) => { // iterate over alerts
            if (alert.bronoEnabled) { // does alert have brono?
              hasAlertsWithBroNo = true; // yes. yes it does
            }
          });
        }
      });
    }
  });

  if (hasAlertsWithBroNo) {
    if (!browserSupportsBroNo) {
      // eslint-disable-next-line
      console.warn('Browser notifications are enabled on the selected board but not supported by this browser.');
    } else if (needPermission) {
      Notification.requestPermission();
    }
  }

  return hasAlertsWithBroNo && browserSupportsBroNo && needPermission
    ? (
      <Dialog
        width={600}
        open={showDialog}
        onClose={() => setShowDialog(false)}
      >
        <DialogTitle>
          <FormattedMessage {...messages.ENABLE_NOTIFICATIONS} />
        </DialogTitle>

        <DialogContent>
          <DialogContentText>
            <FormattedMessage {...messages.ENABLE_NOTIFICATIONS_INFO} />
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setShowDialog(false)}>
            <FormattedMessage {...messages.DISMISS} />
          </Button>
        </DialogActions>
      </Dialog>
    ) : null;
}

export default BroNoConfirm;
